import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import Utilities from '../../helpers/Utilities';

const ChatUserCommunicationResend = (props) => {

    const limitCharacters = Utilities.userCommunicationReasonLimit;

    const [showPopup, setShowPopup] = useState(false);
    const [initialMessage, setInitialMessage] = useState('');

    const handleClosePopup = () => {
        props.handleCloseUserCommunicationReasonPopUp();
    }

    const userCommunicationStatusProper = () => {

        const charCounter = Utilities.charactersCounter(initialMessage);
        if (charCounter > limitCharacters) {
            Utilities.messagePopup('error', `Only ${limitCharacters} characters are allowed!`);
            return false;
        }

        props.handleUserCommunicationResendProper(initialMessage.toString());
    }

    useEffect(() => {
        setShowPopup(props.showUserCommunicationReasonPopUp);
        return () => {
            setInitialMessage('');
        }

    }, [props]);


    return (

        <Modal id="popup-chat-team-profile-restriction-resend" show={showPopup} onHide={handleClosePopup} animation={false} aria-labelledby="contained-modal-title-vcenter" centered size="md" dialogClassName="modal-dialog-theme" backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="font-gotham-bold fs-25 text-center d-inline border-bottom-0 pt-4">{Utilities.labelReasonForResend}</Modal.Header>
            <Modal.Body>

                <div className="col-10 mx-auto form-theme mt-2 mb-4">

                    <div className="form-group border-0">
                        <textarea name="initial_message" className="form-control" autoFocus rows="6" placeholder=" " value={initialMessage} onChange={(e) => setInitialMessage(e.target.value)}></textarea>
                        <label className="form-label bg-transparent">type here</label>
                    </div>

                    <div className="text-center font-gotham-book fs-md-14">
                        <div className='text-color-gray'>{Utilities.number_format(limitCharacters.toString())} characters</div>
                        <div className="text-color-blue cursor-pointer" onClick={() => setInitialMessage('')}>clear</div>
                    </div>

                    <div className="pt-4 mt-2 mx-auto">
                        <button id="btn-confirm-user-communication-resend" type="button" className="btn-theme-black button-has-loader" onClick={() => userCommunicationStatusProper()}>submit</button>
                    </div>

                </div>

            </Modal.Body>
        </Modal>
    )
}

export default ChatUserCommunicationResend;
